import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { Breadcrumb, Space, Table, Spin, Alert, Input, Button, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllEvents } from "../../../redux/Event/actions";
import AddEventButton from "./AddEventButton";
import DeleteEventButton from "./DeleteEventButton";
import EditEventButton from "./EditEventButton";
import ShowEventButton from "./ShowEventButton";
import { FilterOutlined } from '@ant-design/icons';

const { Search } = Input;

const columns = [
  { title: "Name", dataIndex: "eventname", key: "eventname" },
  { title: "Activity", dataIndex: "activity", key: "activity" },
  { title: "Address", dataIndex: "location", key: "location" },
  { title: "Description", dataIndex: "description", key: "description" },
  { title: "User Email", dataIndex: "userEmail", key: "userEmail" }, // New column for User Email
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
    
      <Space size="middle">
        {  console.log('record',record)}
        <ShowEventButton item={record} />
        <EditEventButton item={record} isEdit={true} />
        <DeleteEventButton item={record} />
      </Space>
    ),
  },
];

export default function Event() {
  const dispatch = useDispatch();
  const events = useSelector((state) => state.events?.data || []);
  const loading = useSelector((state) => state.events?.loading || false);
  const [filteredEvents, setFilteredEvents] = useState(events);
  const [searchInput, setSearchInput] = useState("");
  const [searchFilter, setSearchFilter] = useState('eventname'); // Default search filter

  // Fetch events when the component mounts
  useEffect(() => {
    dispatch(getAllEvents());
  }, [dispatch]);

  useEffect(() => {
    setFilteredEvents(events);
  }, [events]);

  const handleSearch = (value) => {
    setSearchInput(value);

    const filtered = events.filter((el) => {
      const searchValue = value.toLowerCase();
      if (!value) return true;

      switch (searchFilter) {
        case 'eventname':
          return el.eventname.toLowerCase().includes(searchValue);
        case 'activity':
          return el.activity.toLowerCase().includes(searchValue);
        case 'location':
          return el.location.toLowerCase().includes(searchValue);
        case 'description':
          return el.description.toLowerCase().includes(searchValue);
        case 'userEmail':
          return el.user?.email?.toLowerCase().includes(searchValue);
        default:
          return true;
      }
    });

    setFilteredEvents(filtered);
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchInput(value);
    handleSearch(value);
  };

  const filterMenu = (
    <Menu>
      <Menu.Item key="eventname" onClick={() => setSearchFilter('eventname')}>
        Event Name
      </Menu.Item>
      <Menu.Item key="activity" onClick={() => setSearchFilter('activity')}>
        Activity
      </Menu.Item>
      <Menu.Item key="location" onClick={() => setSearchFilter('location')}>
        Location
      </Menu.Item>
      <Menu.Item key="description" onClick={() => setSearchFilter('description')}>
        Description
      </Menu.Item>
      <Menu.Item key="userEmail" onClick={() => setSearchFilter('userEmail')}>
        User Email
      </Menu.Item>
    </Menu>
  );

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Spin tip="Updating data..." />
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Alert message="No events found" type="info" />
      </div>
    );
  }

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0px" }}>
        <Breadcrumb.Item>Events</Breadcrumb.Item>
        <div style={{ float: "right", marginTop: 20 }}>
          <Grid container>
            <Grid item>
              <Search
                placeholder="Search"
                value={searchInput}
                onChange={handleSearchChange}
                style={{ minWidth: 150, maxWidth: 220 }}
                enterButton
                onSearch={handleSearch}
              />
              <Dropdown overlay={filterMenu} trigger={['click']}>
                <Button
                  style={{ marginLeft: 10, border: 'none' }}
                  icon={<FilterOutlined />}
                />
              </Dropdown>
              <AddEventButton />
            </Grid>
          </Grid>
        </div>
      </Breadcrumb>
      <br />
      <br />
      <Table
        position={"topCenter"}
        columns={columns}
        dataSource={filteredEvents}
        rowKey="_id" // Assuming _id is the unique identifier for each event
      />
    </div>
  );
}